import React, { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import Footer from "../components/nav/Footer";
import SharedLayout from "./SharedLayout";

interface PublicLayoutProps {
  children?: ReactNode;
}

const PublicLayout = ({ children }: PublicLayoutProps) => {
  return (
    <SharedLayout>
      <div className=" mx-auto md:px-8">{children || <Outlet />}</div>
      <Footer />
    </SharedLayout>
  );
};

export default PublicLayout;
